module.exports = __webpack_public_path__ + "img/bayer-leverkusen-logo-icon.f1351d9b.png";